import React from 'react';
import {observer} from 'mobx-react';

import {DirectoryStoreContextV2} from 'core/stores/RootStore.js';

export default
@observer
class ResultsSummaryV2 extends React.Component {
    static contextType = DirectoryStoreContextV2;

    render() {
        const {locationSearchAPI} = this.context;
        const {displayRangeStart, displayRangeEnd, total} = locationSearchAPI;
        const {className} = this.props;
        if (!locationSearchAPI.results?.length) {
            return null;
        }
        return (
            <p
                className={
                    className ? `results-summary ${className}` : 'results-summary'
                }
            >
                Showing{' '}
                <span className="results-summary__range">
                    {`${displayRangeStart}-${displayRangeEnd}`}
                </span>{' '}
                {`of ${total} results`}
            </p>
        );
    }
}
